import { useState } from 'react'
import { InputLabel, TextField } from '@mui/material'
import { Box } from '@mui/system'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded'

const OfoqDropdown = ({ name, state, refState, required, customStyle, ...props }) => {
  const formLabel = name.replace('_', ' ')
  const [open, setOpen] = useState(false)

  const updateRefState = (value) => {
    refState(value)
  }

  const handleIconChange = () => (
    open ? (
      <ExpandLessRoundedIcon sx={styles.icon} />
    ) : (
      <ExpandMoreRoundedIcon sx={styles.icon} />
    )
  )
  return (
    <Box sx={customStyle}>
      <InputLabel
        htmlFor={name}
        sx={[styles.formInputLabel, required && styles.formInputLabelRequired]}>
        {formLabel}
      </InputLabel>

      <Box sx={styles.fieldContainer}>
        <TextField
          id={name}
          label={!state && `Select ${formLabel}`}
          select
          SelectProps={{
            onClose: () => setOpen(false),
            onOpen: () => setOpen(true),
            IconComponent: () => handleIconChange(),
          }}
          InputLabelProps={{ shrink: false }}
          sx={styles.formField}
          value={state}
          onChange={(value) => {
            updateRefState(value.target.value)
          }}
          {...props}
        />
      </Box>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
  },

  formField: {
    display: 'flex',
    width: '100%',
    margin: '10px 0 20px 0',
    height: {
      xs: '40px',
      md: '50px',
    },
    transition: 'all 0.5s ease',
    textTransform: 'capitalize',
    '& .MuiFormHelperText-root': {
      display: 'none',
      color: 'error.main',
      margin: '0',
      marginTop: '5px',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fafbfc',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '15px',
      border: 'solid 1px #e2e8ee',
      transition: 'all 0.3s ease-in-out',
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      padding: '12px',
    },
    '& .MuiAlert-root': {
      width: '100%',
    },
  },

  formInputLabel: {
    display: 'flex',
    alignItems: 'center',
    transform: 'translate(0,0) scale(1)',
    textTransform: 'capitalize',
    color: 'common.black',
    fontSize: '14px',
    width: 'max-content',
    paddingRight: '18px',
  },

  formInputLabelRequired: {
    '&:after': {
      content: '"*"',
      color: 'common.white',
      top: '3.4px',
      right: '1.4px',
      position: 'absolute',
      lineHeight: 1.2,
      fontFamily: 'serif',
      fontSize: '17px',
      fontWeight: '900',
    },
    '&:before': {
      content: '" "',
      position: 'absolute',
      width: '12px',
      height: '12px',
      backgroundColor: 'primary.main',
      borderRadius: '50%',
      display: 'inline-block',
      textAlign: 'center',
      verticalAlign: 'middle',
      top: '5px',
      right: '0',
    },
  },

  formFieldError: {
    '& .MuiFormHelperText-root': {
      display: 'flex',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red !important',
    },
  },

  fieldContainer: {
    position: 'relative',

  },

  numberFieldBtns: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    right: 0,
    top: '10px',

    '& button:nth-of-type(1)': {
      borderTopRightRadius: '5px',
    },

    '& button:nth-of-type(2)': {
      borderBottomRightRadius: '5px',
    },

    '& button': {
      minWidth: '30px',
      maxHeight: '28px',
      backgroundColor: 'primary.main',
      borderRadius: 0,

      '& svg': {
        fontSize: '16px',
        color: 'white',
      },

      '&:hover': {
        backgroundColor: 'primary.main',
        '& svg': {
          color: 'white',
        },
      },
    },
  },
  icon: {
    color: 'text.hint',
    marginRight: '15px',
  },
}

export default OfoqDropdown
